<template>
  <div>
    <h1>Style Guide</h1>

  </div>
</template>

<script>
export default {
  name: 'style-guide',
  data () {
    return {
      msg: ''
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// StyleGuidePage.vue?4e3fc7a0